export default __webpack_public_path__ + "static/media/headshot.e0bb9ca3.jpg";